<template>
  <b-card no-body class="mb-1">
    <b-card-header header-tag="header" class="p-0 mt-1">
      <b-btn block href="#" v-b-toggle.dealBonds variant="info" class="text-left">Capital Structure</b-btn>
    </b-card-header>
    <b-collapse id="dealBonds" visible>
      <b-card-body>
        <b-form-checkbox v-model="showMacrBonds" class="text-left mb-3">Show MACR bonds</b-form-checkbox>
        <table class="table table-sm table-hover">
          <thead>
            <th class="text-left">Bond Name</th>
            <th class="text-left">CUSIP</th>
            <th class="text-right">Original Balance</th>
            <th class="text-right">Current Balance</th>
            <th class="text-right">Factor</th>
            <th class="text-right">Coupon</th>
            <th class="text-center">Floater Formula</th>
            <th class="text-right">Original<br>Enhancement</th>
            <th class="text-right">Original<br>Thickness</th>
            <th class="text-right">Current<br>Enhancement</th>
            <th class="text-right">Current<br>Thickness</th>
            <th class="text-right">WAL</th>
            <th class="text-right">Principal Window</th>
            <th class="text-right">Write Down</th>
          </thead>
          <tbody>
            <tr v-for="bondName in filteredBondNames" :key=bondName>
              <td class="text-left">
                <router-link :to="{path:'/bond_analysis', query: {dealName : $store.getters.dealName, bondName: bonds[bondName].BondName}}">{{bonds[bondName].BondName}}</router-link>
              </td>
              <td class="text-left">{{bonds[bondName].Cusip}}</td>
              <td class="text-right">{{bonds[bondName].OriginalBalance}}</td>
              <td class="text-right">{{bonds[bondName].CurrentBalance}}</td>
              <td class="text-right">{{bonds[bondName].Factor}}</td>
              <td class="text-right">{{bonds[bondName].Coupon}}</td>
              <td class="text-center">{{bonds[bondName].FloaterFormula}}</td>
              <td class="text-right">{{bonds[bondName].OriginalEnhance}}</td>
              <td class="text-right">{{bonds[bondName].OriginalThickness}}</td>
              <td class="text-right">{{bonds[bondName].CurrentEnhance}}</td>
              <td class="text-right">{{bonds[bondName].CurrentThickness}}</td>
              <td class="text-right blue">{{bonds[bondName].Wal}}</td>
              <td class="text-right blue">{{bonds[bondName].PrincipalWindow}}</td>
              <td class="text-right blue">{{bonds[bondName].WritedownPct}}</td>
            </tr>
          </tbody>
        </table>
      </b-card-body>
    </b-collapse>
  </b-card>
</template>

<script>
export default {
  props: {
    bonds: Object
  },
  data() {
    return {
      showMacrBonds: false
    }
  },
  computed: {
    filteredBondNames() {
      let res = Object.keys(this.bonds).filter(bondName => !this.bonds[bondName].IsMACR)
      if (this.showMacrBonds) { res = Object.keys(this.bonds) }
      return res
    }
  }
}
</script>

